module.exports = __webpack_public_path__ + "static/media/groupChess.625e1dde.png";